/*
 * COPYRIGHT 2022,2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 *
 */

import { BorderRadius, Colours, FontSize } from 'yospace-ui-components';

export class EnvironmentViewStyles {
    static STYLES = {
        main: {
            padding: '10px 0px 10px 0px'
        },
        innerContainer: {
            backgroundColor: Colours.highlight7,
            borderRadius: BorderRadius.medium,
            width: '118px', height: '24px'
        },
        text: {
            fontWeight: '700',
            fontSize: FontSize.small2,
            textAlign: 'center',
            lineHeight: '24px'
        }
    }

    static getMain() {
        return EnvironmentViewStyles.STYLES.main;
    }

    static getInnerContainer() {
        return EnvironmentViewStyles.STYLES.innerContainer;
    }

    static getText() {
        return EnvironmentViewStyles.STYLES.text;
    }
}
